import _ from 'lodash';
import { useEffect } from 'react';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
};

const useReportsIp = () => {
  const { state: { reportsIp = initialState }, dispatch } = useGlobalContext('reportsIp'),
    { actions: headerActions } = useHeader();


  const { data } = useFetch({
    url: 'reports-ip/list',
    params: { term: reportsIp.term, offset: reportsIp.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Lista de Endereços IP/DDNS',
      count: _.get(data, 'rows.length', 0),
      loading: _.get(reportsIp, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, reportsIp]);

  const list = (offset = 0, term) => {
    dispatch({ offset, term });
  };

  const pageChange = (offset = 0) => {
    dispatch({ offset });
  };

  return {
    state: {
      ...reportsIp,
      data: data || { rows: [] },
      loading: !data,
    },
    actions: {
      pageChange,
      list,
    },
  };
};

export default useReportsIp;
